<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-math-log</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <ChangeLogForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <template>
      <div class="link-list">
        <Toolbar
          :handle-add="() => addHandlerSub('Link',item)"
        />
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex sm12>
              <h1>{{$t('version.link.links')}}</h1>
            </v-flex>
            <v-flex lg12>
              <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                <LinkFilterForm
                  ref="filterForm"
                  :values="filters"
                  slot="filter"
                />
              </DataFilter>

              <br />

              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="itemsSub"
      :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                :loading="isLoading"
                :loading-text="$t('global.loading')"
                :options.sync="options"
                :server-items-length="totalItems"
                class="elevation-1"
                item-key="@id"
                show-select
                @update:options="onUpdateOptions"
@click:row="editHandlerSubEvent"
              >

                <ActionCell
                slot="item.action"
                slot-scope="props"
                :handle-edit="() => editHandlerSub(item,'Link',props.item)"
                ></ActionCell>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ChangeLogForm from '../../components/changelog/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import LinkFilterForm from '../../components/link/Filter';
import DataFilter from '../../components/DataFilter';

const servicePrefix = 'ChangeLog';

export default {
  name: 'ChangeLogUpdate',
  servicePrefix,

  components: {
    Loading,
    Toolbar,
    ChangeLogForm,
    ActionCell,
    LinkFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('version.link.name'), value: 'name' },
        { text: this.$t('version.link.url'), value: 'url' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'changeLog' : this.$route.params.id,
      },
      selected: []
    };
  },
    mixins: [ListMixin,UpdateMixin],
  computed: {
    ...mapFields('changelog', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('changelog', ['find']),
    ...mapFields('link', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    ...mapGetters('link', {
          itemsSub: 'list'
    }),

  },

  methods: {
    ...mapActions('changelog', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    ...mapActions('link', {
      getPage: 'fetchAll',
    }),
    editHandlerSubEvent(value) {
      this.editHandlerSub(this.item,'Link',value);
    }
  }
};
</script>
